import { lastValueFrom } from 'rxjs';

import { Injectable, inject } from '@angular/core';

import { queryOptions } from '@tanstack/angular-query-experimental';

import { UnitService } from '../unit.service';

export const UNIT_QUERY_KEYS = {
  hasExternalUnit: (projectId: string, unitId: string) => ['project', projectId, 'unit', unitId, 'hasExternalUnit'],
  hasExternalUnitFromStudy: (projectId: string, studyId: string, unitId: string) => [
    'project',
    projectId,
    'study',
    studyId,
    'unit',
    unitId,
    'hasExternalUnit',
  ],
};

@Injectable({
  providedIn: 'root',
})
export class UnitQueryService {
  readonly #unitService = inject(UnitService);

  hasExternalUnitPresence(projectId: string, unitId: string) {
    return queryOptions({
      queryKey: UNIT_QUERY_KEYS.hasExternalUnit(projectId, unitId),
      queryFn: () => lastValueFrom(this.#unitService.hasExternalUnitPresence(projectId, unitId)),
      enabled: !!unitId,
    });
  }

  hasExternalUnitPresenceFromStudy(projectId: string, studyId: string, unitId: string) {
    return queryOptions({
      queryKey: UNIT_QUERY_KEYS.hasExternalUnitFromStudy(projectId, studyId, unitId),
      queryFn: () => lastValueFrom(this.#unitService.hasExternalUnitPresenceFromStudy(projectId, studyId, unitId)),
      enabled: !!unitId,
    });
  }
}
